
  import { mapGetters } from "vuex"
  import { AlertService } from "@/services/AlertService"
  import {  DnFormInput} from "@/components/Elements";
  import { ErrorLogService } from "@/services/";

  export default {
    components: {
      DnFormInput,
    },
    data: () => ({
      subject: "",
      message: "",
    }),
    computed: {
      ...mapGetters([
        "user", 
        "hasPermission",
        "getContentItem"
      ]),
      userIsWebDeveloper: function () {
        return this.hasPermission("IsWebDeveloper")
      },
      alertBus: function () {
        return AlertService.getAlertHub();
      }
    },
    methods: {
      async sendAlert(){
        // If signalr service is disconnected then wait for reconnect
        if(AlertService.getAlertHub().connectionState == 0){
          await AlertService.startAlertHub();
        }
        
        AlertService.getAlertHub().invoke("SendAlert", this.subject, this.message)
          .catch(function(err) {
            return ErrorLogService.LogException(err);
          });
      },
      async sendReleaseAlert(){
        this.subject = this.getContentItem("dealerNetReleaseAlertSubject");
        this.message = this.getContentItem("dealerNetReleaseAlertMessage");
        await this.sendAlert();
        this.clearAlert();
      },
      clearAlert(){
        this.subject = "";
        this.message = "";
      },
    },
  }
